import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

const requiredKeys: Array<keyof typeof firebaseConfig> = [
  'apiKey',
  'authDomain',
  'databaseURL',
  'projectId',
  'storageBucket',
  'messagingSenderId',
  'appId',
];

const missingKeys = requiredKeys.filter((key) => !firebaseConfig[key]);

export const isFirebaseConfigured = missingKeys.length === 0;

if (!isFirebaseConfigured) {
  console.warn(
    `[Firebase] Missing environment variables: ${missingKeys.join(', ')}. ` +
      'Firebase-backed features will be disabled until these are set.'
  );
}

let initializedApp: ReturnType<typeof initializeApp> | null = null;
let initializedAuth: ReturnType<typeof getAuth> | null = null;
let initializedDatabase: ReturnType<typeof getDatabase> | null = null;
let initializedStorage: ReturnType<typeof getStorage> | null = null;

if (isFirebaseConfigured) {
  try {
    initializedApp = initializeApp(firebaseConfig);
    initializedAuth = getAuth(initializedApp);
    initializedDatabase = getDatabase(initializedApp);
    initializedStorage = getStorage(initializedApp);
  } catch (error) {
    console.error(
      '[Firebase] Failed to initialize. Check your Firebase config values in .env.local.',
      error
    );
  }
}

export const app = initializedApp;
export const auth = initializedAuth;
export const database = initializedDatabase;
export const storage = initializedStorage;
